module.exports = __webpack_public_path__ + "static/img/5.2185e32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/snip3down/5.png
// module id = JnJC
// module chunks = 35